export const firebaseConfig = {
  apiKey: "AIzaSyAZ1o50rI9_jBaxJhupcayerFgFusAQWvY",
  authDomain: "feature-tracker-8ca2b.firebaseapp.com",
  databaseURL: "https://feature-tracker-8ca2b.firebaseio.com",
  projectId: "feature-tracker-8ca2b",
  storageBucket: "feature-tracker-8ca2b.appspot.com",
  messagingSenderId: "592180175649",
  appId: "1:592180175649:web:edbba5ecb3bb7a4b445460",
  measurementId: "G-0QEHP055R1"
};
